<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="View Log" name="first">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters" label-width="100px">
						<el-form-item label="Log Type">
							<el-select v-model="filters.nType" placeholder="">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="reGetList()">
								Search
							</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="sName" label="User Name"></el-table-column>
						<el-table-column prop="dTime" label="Log Time"></el-table-column>
						<el-table-column prop="nType" label="Log Type" :formatter="nType"></el-table-column>
						<el-table-column prop="sObjectName" label="Object Name"></el-table-column>
						<el-table-column prop="sBehaviorName" label="Behaviour_Name"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total"></el-pagination>
					</div>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import { getBehaviorListt } from "../../api/api";
	export default {
		data() {
			return {
				activeName: 'first',
				options: [{
						id: "1",
						name: "User Sign In"
					}, {
						id: "2",
						name: "User Upload"
					}
					// 				, {
					// 					id: "3",
					// 					name: "User Empowerment"
					// 				}, {
					// 					id: "4",
					// 					name: "User Query"
					// 				}, {
					// 					id: "5",
					// 					name: "Save View"
					// 				}
				],
				filters: {
					nType: "1",
					pageSize: 10,
					currentPage: 1
				},
				total: 0,
				tableData: []
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			nType(data) {
				for(var i = 0; i < this.options.length; i++) {
					if(this.options[i]['id'] == data.nType) {
						return this.options[i]['name'];
					}
				}
			},
			handleCurrentChange(page) {
				this.filters.currentPage = page;
				this.getList();
			},
			reGetList: function() {
				this.filters.currentPage = 1;
				this.getList();
			},
			getList: function() {
				var param = Object.assign({}, this.filters);
				getBehaviorListt(param).then(res => {
					this.tableData = res.data;
					this.total = res.page.totalCount * 1;
				});
			}
		}
	};
</script>

<style></style>


// WEBPACK FOOTER //
// view.vue?6c182930